const en = {
  title: 'Message Center',
  filterTpye: 'message category',
  plzSelect: 'Please select',
  serviceType: 'Service announcement',
  releaseTime: 'Message release time',
  messageTitle: 'Message title',
  messageContent: 'Message content',
  sendTime: 'Message release time',
  operation: 'Operation',
  viewDetails: 'View details',
  allRead: 'All read',
  messageDetails: 'Message details',
  confirm: 'Confirm',
  close: 'Close',
}

export default en
